import {Injector} from '@angular/core';

export class ServiceLocator {
    static injector: Injector;
}



// WEBPACK FOOTER //
// ./src/app/core/helpers/service-locator.ts